import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem('user'));
  } catch (_error) {
    return null;
  }
}

const GuestRoute = (props) => {
  const isAuthenticated = Boolean(props.user || getStoredUser());

  if (isAuthenticated) {
    return <Redirect to="/" />;
  }

  return <Route {...props} />;
};

const mapStateToProps = (state) => {
  return {
    user: state.userReducer.user,
  };
};

export default connect(mapStateToProps)(GuestRoute);
